import CONSTANTS from '../../util/constants';

const initState = {
    isLoading: false,
    id: "",
    lotName: "",
    getLotData: [],
    addLotData: [],
    editLotData: [],
    getLotsById: [],
    getLotDivisionData: [],
    getSpaceByLotData: [],
    getSpaceLogData: [],
    getLotsSpaceData: [],
    getLotCheckWorkSheet: [],
    isLotSpaceAPICalled: false
}

const LotReducer = (state = initState, { type, payload }) => {


    switch (type) {
        case CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.LOTS_NAME_UPDATE:
            return {
                ...state,
                lotName: payload.value
            }

        case CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.ADD_LOTS_API_SUCCESS:
            return {
                ...state,
                addLotData: payload.value
            }

        case CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.GET_LOTS_API_SUCCESS:

            return {
                ...state,
                getLotData: payload.value
            }

        case CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.EDIT_LOTS_API_SUCCESS:

            return {
                ...state,
                editLotData: payload.value
            }
        case CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.GET_LOTS_DIVISION_MANAGEMENT_API_SUCCESS:

            return {
                ...state,
                getLotDivisionData: payload.value
            }
        case CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.GET_SPACES_BY_LOTID_MANAGEMENT_API_SUCCESS:

            return {
                ...state,
                getSpaceByLotData: payload.value
            }
        case CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.GET_SPACELOGS_MANAGEMENT_API_SUCCESS:

            return {
                ...state,
                getSpaceLogData: payload.value
            }
        case CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.GET_LOTS_SPACE_DATA:

            return {
                ...state,
                getLotsSpaceData: payload.value
            }
        case CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.GET_LOT_SPACE_API_CALLED:
            return {
                ...state,
                isLotSpaceAPICalled: payload.value
            }

        default:
            return state
    }
}

export default LotReducer;
